var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner container" }, [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "line-1" }, [
          _vm._v("\n            以诚为本 共建共赢\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-2" }, [
          _vm._v("\n            科学管理 创新发展\n        "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }